// document.addEventListener('on:variant:change', (event) => {

  
//   const selectedVariant = event.detail.variant;
  

//   const allVariants = event.detail.allVariants;
  

//   const allVariantMetafieldData = JSON.parse(document.querySelector('#variant-metafield-data').textContent)
//   console.log(allVariantMetafieldData);
  
//   const variantMetafieldText = document.querySelector('#variant-metafield')
//   console.log(variantMetafieldText);
//   variantMetafieldText.innerHTML = allVariantMetafieldData[selectedVariant.id]


//   const variantMetafieldInput = document.querySelector('#backorder-status')
//   console.log(variantMetafieldText);
//   variantMetafieldInput.value = allVariantMetafieldData[selectedVariant.id]
// });

document.addEventListener('on:variant:change', (event) => {
  const selectedVariant = event.detail.variant;

  const metafieldDataElement = document.querySelector('#variant-metafield-data');
  const variantMetafieldText = document.querySelector('#variant-metafield');
  const variantMetafieldInput = document.querySelector('#backorder-status');

  if (!selectedVariant || !metafieldDataElement) return;

  const allVariantMetafieldData = JSON.parse(metafieldDataElement.textContent);
  const metafieldValue = allVariantMetafieldData[selectedVariant.id] || '';

  if (variantMetafieldText) {
    variantMetafieldText.textContent = metafieldValue;
    variantMetafieldText.hidden = metafieldValue === '';
  }

  if (variantMetafieldInput) {
    variantMetafieldInput.value = metafieldValue;
  }
});